export const blockIconsImageMusicNote = (
	<span className='material-symbols-outlined'>music_note</span>
);
